import { metricsService } from 'src/services/metrices'
import { sendSlackNotification } from '../api'
import { APP_VERSION } from '../config/config'
import { SLACK_CHANNELS } from '../slackChannels'
import { getAccessLevel } from './accessLevel'
import { getSession } from './localStorage'

const appVersion = APP_VERSION

export function getFrontendAlertChannel(): string {
  const userData = getSession('data')
  if (userData?.internal) {
    metricsService.trackError('alert', SLACK_CHANNELS.FRONTEND_ALERTS_INTERNAL)
    return SLACK_CHANNELS.FRONTEND_ALERTS_INTERNAL
  }
  metricsService.trackError('alert', SLACK_CHANNELS.FRONTEND_ALERTS)
  return SLACK_CHANNELS.FRONTEND_ALERTS
}


export function getEfrontendOncall(): string {
  
  return SLACK_CHANNELS.E_FRONTEND_ONCALL
}

export function getfeLogsOncall(): string {
  const userData = getSession('data')
  if (userData?.internal) {
    return
  }
  else {
    return SLACK_CHANNELS.FE_LOGS
  }
}


export function downloadSuccessSlackAlert(obj: { apiUrl?: string; title?: string }) {
  const { apiUrl, title } = obj

  const { email = undefined, org = undefined } = (() => {
    try {
      const data = getSession('data')
      return data || {}
    } catch (err) {
      return {}
    }
  })()

  sendSlackNotification({
    message: 'Download CSV success',
    channel: SLACK_CHANNELS.FE_LOGS,
    title:
      `Download success for\n` +
      (org ? `\`org: ${org}\`\n` : ``) +
      (email ? `\`user: ${email}\`\n` : ``) +
      `\`page URL: <${window.location.href}|${window.location.pathname}>\`\n` +
      (title ? `\`Table title: ${title}\`\n` : ``) +
      (apiUrl ? `\`API URL: ${apiUrl}\`\n` : ``)
  })
}

export function downloadFailedSlackAlert(obj: { apiUrl?: string; err: Error }) {
  const { apiUrl, err } = obj

  const { email = undefined, org = undefined } = (() => {
    try {
      const data = getSession('data')
      return data || {}
    } catch (err) {
      return {}
    }
  })()

  metricsService.trackError('API', 'unknown', 'unknown', `Download CSV failed: ${err.message}`, apiUrl || 'unknown', {
    userType: process.env.NODE_ENV === 'production' ? 'external' : 'internal',
    duration: -1,
    version: appVersion,
    pageUrl: window.location.pathname,
    apiUrl: apiUrl,
    email: email,
    org: org,
    accessLevel: getAccessLevel(getSession('data')),
    methodName: 'GET'
  })

  sendSlackNotification({
    message: 'Download CSV failed',
    channel: getFrontendAlertChannel(),
    title:
      `Download failed for\n` +
      (org ? `\`org: ${org}\`\n` : ``) +
      (email ? `\`user: ${email}\`\n` : ``) +
      `\`page URL: <${window.location.href}|${window.location.pathname}>\`\n` +
      `\`error message: ${err.message}\`\n` +
      (apiUrl ? `\`API URL: ${apiUrl}\`\n` : ``)
  })
}
